<template>
  <section class="c-popularCategories">
    <content-headline
      class="c-popularCategories_headline"
      titleTag="h2"
      titleText="人気カテゴリ"
      :rightLink="headlineLink"
    />
    <div class="c-popularCategories_list">
      <popular-category
        class="c-popularCategories_item"
        v-for="c in categories"
        :key="c.id"
        :categoryId="c.id"
        :text="c.text"
        :iconSrc="c.iconSrc"
      />
    </div>
  </section>
</template>

<script>
import ContentHeadline from '~/components/molecules/ContentHeadline'
import PopularCategory from './PopularCategory'

export default {
  name: 'PopularCategories',
  components: {
    ContentHeadline,
    PopularCategory
  },
  data() {
    return {
      headlineLink: {
        text: 'すべてのカテゴリを見る',
        link: '/search',
        isNuxtLink: true
      },
      categories: [
        {
          id: 9,
          text: 'イラスト・<br>漫画',
          iconSrc: require('~/assets/images/components/HomeMainContent/PopularCategories/icon_illust.svg')
        },
        {
          id: 18,
          text: 'デザイン',
          iconSrc: require('~/assets/images/components/HomeMainContent/PopularCategories/icon_design.svg')
        },
        {
          id: 10,
          text: '動画制作',
          iconSrc: require('~/assets/images/components/HomeMainContent/PopularCategories/icon_media.svg')
        },
        {
          id: 22,
          text: 'Web<br>サイト制作',
          iconSrc: require('~/assets/images/components/HomeMainContent/PopularCategories/icon_website.svg')
        },
        {
          id: 23,
          text: '音楽・<br>ナレーション',
          iconSrc: require('~/assets/images/components/HomeMainContent/PopularCategories/icon_voice.svg')
        },
        {
          id: 16,
          text: 'マーケティング',
          iconSrc: require('~/assets/images/components/HomeMainContent/PopularCategories/icon_seo.svg')
        },
        {
          id: 3,
          text: '占い',
          iconSrc: require('~/assets/images/components/HomeMainContent/PopularCategories/icon_divination.svg')
        },
        {
          id: 2,
          text: '悩み・<br>話し相手',
          iconSrc: require('~/assets/images/components/HomeMainContent/PopularCategories/icon_health.svg')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.c-popularCategories {
  &_headline {
    margin-bottom: 16px;
    line-height: 1;
  }
  &_list {
    display: flex;

    justify-content: flex-start;
  }
  &_item {
    width: 12.5%;
  }
}

@media (max-width: breakpoint(Home, M)) {
  .c-popularCategories {
    padding: 0 12px;
    &_list {
      flex-wrap: wrap;
    }
    &_item {
      width: 25%;
      &:nth-child(n + 5) {
        margin-top: 16px;
      }
    }
  }
}
</style>
